import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Card, Table } from "reactstrap";
import { useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { get, del, put } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Pass from "../../../components/Common/Pass";
import passDesign1 from "../../../../src/assets/peach.svg";
import passDesign2 from "../../../../src/assets/green.svg";
import passDesign3 from "../../../../src/assets/purple.svg";
export default function PassDetail() {
  document.title = "Pass Detail | Elevated - Admin Dashboard";
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const gymId = searchParams.get("gymId");
  const passId = location.state?.passData?.data?.id;
  const [passData, setPassData] = useState(null);
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const { appRole, userPermissions } = useSelector((state) => {
    return state.auth.currentUser;
  });
  const fetchPass = async (id) => {
    setLoading(true);
    try {
      const response = await get(`${endpoints.pass}/${id}`);
      setPassData(response?.data?.data);
      setContent(response?.data?.data?.content?.htmlContent);
    } catch (error) {
      console.error("Error fetching pass data:", error);
      setPassData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (passId) {
      fetchPass(passId);
    }
  }, [passId]);

  const handleEditPass = () => {
    if (passData) {
      navigate(`/add-passes?passId=${passId}&gymId=${passData?.gymId}`);
    }
  };

  const handleDeletePass = async () => {
    try {
      await del(`${endpoints.pass}/${passId}`);
      toast.success("Pass Deleted Successfully", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
      navigate(`/list-passes?gymId=${passData?.gymId}`);
    } catch (error) {
      console.error("Error deleting pass:", error);
    }
  };
  const formatNumber = (num) => {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(2) + "B";
    } else if (num >= 1000000) {
      return (num / 1000000).toFixed(2) + "M";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(2) + "K";
    }
    return num.toFixed(2);
  };
  return (
    <div className="">
      <Container fluid>
        <Card className="rounded-4 p-4">
          <Row className="justify-content-between align-items-center">
            <Col md={6}>
              <h2 className="fw-bold font-size-20 ff-sora primary-black">
                Pass Details
              </h2>
            </Col>
            <Col md={6} xs={12} className="d-flex justify-content-end">
              {userPermissions?.passes?.["Delete Pass"] && (
                <Button
                  color="white"
                  className="me-2 rounded-pill1"
                  onClick={handleDeletePass}
                >
                  Delete Pass
                </Button>
              )}
              {userPermissions?.passes?.["Update Pass"] && (
                <Button className="rounded-pill" onClick={handleEditPass}>
                  Edit Pass
                </Button>
              )}
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={12}>
              <span className="font-size-16 fw-normal  fw-bold ff-sora secondary-black">
                General Info
              </span>
              <Col className="mt-3" xs={12} sm={12} md={12} lg={12} xl={12}>
                <Pass
                  code={
                    passData?.name +
                    passData?.coinsPrice +
                    passData?.duration +
                    passData?.gym?.name
                  }
                  name={passData?.name || "N/A"}
                  price={passData?.price * 10}
                  duration={passData?.duration}
                  filter={
                    passData?.duration === "oneday"
                      ? passDesign1
                      : passData?.duration === "oneweek"
                      ? passDesign2
                      : passData?.duration === "onemonth"
                      ? passDesign3
                      : null
                  }
                  address={passData?.gym?.name}
                  createdAt={passData?.createdAt || "N/A"}
                />
              </Col>
              <div
                className="table-responsive hide-scrollbar rounded-4"
                style={{ height: "300px" }}
              >
                {loading ? (
                  <div className=" text-center font-size-16 fw-normal fw-bold ff-sora secondary-black">
                    {/* //loading... */}
                  </div>
                ) : passData ? (
                  <Table
                    className="table table-borderless"
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      overflow: "hidden",
                    }}
                  >
                    <tbody style={{ minHeight: "550px" }}>
                      <tr>
                        <td
                          className="font-size-16 col-2 fw-normal ff-sora light-black"
                          style={{ color: "#9e9e9e" }}
                        >
                          Pass Name
                        </td>
                        <td
                          className="font-size-16 fw-normal ff-sora secondary-black text-capitalize"
                          style={{ width: "60%", color: "#525252" }}
                        >
                          {passData.name}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className=" font-size-16 fw-normal ff-sora"
                          style={{ color: "#9e9e9e" }}
                        >
                          Pass Type
                        </td>
                        <td
                          className="font-size-16 fw-normal ff-sora secondary-black"
                          style={{ color: "#525252" }}
                        >
                          {passData.duration == "oneday"
                            ? "One Day"
                            : passData.duration == "oneweek"
                            ? "One Week"
                            : passData.duration == "onemonth"
                            ? "One Month"
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="font-size-16 fw-normal ff-sora light-black"
                          style={{ color: "#9e9e9e" }}
                        >
                          Price
                        </td>
                        <td
                          className="font-size-16 fw-normal ff-sora secondary-black"
                          style={{ color: "#525252" }}
                        >
                          ${formatNumber(passData.price)}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="font-size-16 fw-normal ff-sora light-black"
                          style={{ color: "#9e9e9e" }}
                        >
                          Pass Content
                        </td>
                        <td
                          className="font-size-16 fw-normal ff-sora secondary-black"
                          style={{ color: "#525252" }}
                        >
                          <div
                            dangerouslySetInnerHTML={{ __html: content }}
                          ></div>
                        </td>
                      </tr>
                      <tr>
                        <td
                          className=" font-size-16 fw-normal ff-sora light-black"
                          style={{ color: "#9e9e9e" }}
                        >
                          Gym/Club
                        </td>
                        <td
                          className="font-size-16 fw-normal ff-sora secondary-black"
                          style={{ color: "#525252" }}
                        >
                          {passData.gym.name}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="font-size-16 fw-normal ff-sora light-black"
                          style={{ color: "#9e9e9e" }}
                        >
                          Total Sold
                        </td>
                        <td
                          className="font-size-16 fw-normal ff-sora secondary-black"
                          style={{ color: "#525252" }}
                        >
                          {passData.buyCount}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="font-size-16 fw-normal ff-sora light-black"
                          style={{ color: "#9e9e9e" }}
                        >
                          Expires At
                        </td>
                        <td
                          className="font-size-16 fw-normal ff-sora secondary-black"
                          style={{ color: "#525252" }}
                        >
                          {passData?.expiresAt
                            ? new Date(passData?.expiresAt).toLocaleDateString()
                            : "N/A"}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                ) : (
                  <div
                    className=" text-center font-size-16 fw-normal ff-sora secondary-black"
                    style={{ color: "#525252" }}
                  >
                    No pass data available
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Card>
        <div
          className="d-flex justify-content-between align-items-center"
          style={{
            height: "0px",
            position: "sticky",
            bottom: "0",
            zIndex: "10",
          }}
        ></div>
      </Container>
    </div>
  );
}
